export default "__VITE_ASSET__GVpypxuS__"